import React, { useState } from 'react';
import { Header, Icon, Loader, Message } from 'semantic-ui-react';

import { useGetUnknownCallerCommunications } from './hooks';
import UnknownCallLogTable from './unknownCallLogTable';

interface Props {
  archived: boolean
}

const UnknownCallLog: React.FC<Props> = ({ archived }) => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isRefreshLoading, setIsRefreshLoading] = useState<boolean>(false);

  const { communicationsData, communicationsError, communicationsMutate, isLoading } =
    useGetUnknownCallerCommunications(archived);

  const handleErrorMessage = (errorString: string) => {
    setErrorMessage(errorString);
  };

  const handleRefresh = async () => {
    setIsRefreshLoading(true);

    await communicationsMutate();

    setIsRefreshLoading(false);
  };

  return (
    <div>
      <Header as="h3" color="red">
        <Icon name="users" size="mini" color="red" />
        <Header.Content>
          {!archived ? "Unknown Communications" : "Archived Communications"}{' '}
          <>
            {' '}
            <Icon name="refresh" onClick={handleRefresh} style={{ cursor: 'pointer' }} loading={isRefreshLoading} />
          </>
        </Header.Content>
      </Header>
      {isLoading && <Loader active inline="centered" />}
      {communicationsData && !communicationsData.entry && (
        <Message content="No Communications found!" header="Info" warning />
      )}
      {communicationsData && communicationsData.entry && !isLoading && (
        <UnknownCallLogTable
          communicationsData={communicationsData}
          communicationsMutate={communicationsMutate}
          handleErrorMessage={handleErrorMessage}
          archived={archived}
        />
      )}
      {communicationsError && !isLoading && (
        <Message negative>
          <Message.Header>Oops! Something went wrong.</Message.Header>
          <p>{communicationsError.message}</p>
        </Message>
      )}
      {errorMessage && (
        <Message content={errorMessage} onDismiss={() => handleErrorMessage('')} negative size="small" />
      )}
    </div>
  );
};

export default UnknownCallLog;
